module.exports = __webpack_public_path__ + "static/main-72de17b6c5aa5f721a976ea92d393deb.png";